import apis, { Campaign } from './services.api';

export type {
  Campaign,
};

function getCampaigns(): Promise<Campaign[]> {
  return apis.getCampaigns();
}

async function getDefaultCampaign(): Promise<Campaign | null> {
  const campaignCode = 'AMST';
  let defaultCampaign: Campaign | null = null;

  await apis.getCampaigns()
    .then(
      (campaigns) => {
        for (let i = 0; i < campaigns.length; i++) {
          if (campaigns[i].campaignCode === campaignCode) {
            defaultCampaign = campaigns[i];
            break;
          }
        }
      },
    );

  return defaultCampaign;
}

async function getCampaignForUtmCampaign(utmCampaign: string): Promise<Campaign | null> {
  let foundCampaign: Campaign | null = null;

  await apis.getCampaigns()
    .then(
      (campaigns) => {
        campaigns.forEach((value) => {
          if (value.campaignCode?.toUpperCase() === utmCampaign.toUpperCase()) {
            foundCampaign = value;
          }
        });
      },
    );
  return foundCampaign;
}

export default {
  getCampaigns,
  getDefaultCampaign,
  getCampaignForUtmCampaign,
};
